<template>
  <b-row>
    <b-col cols="12">
      <marketplace-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import MarketplaceContent from './MarketplaceContent.vue'

export default {
  components: {
    BRow,
    BCol,

    MarketplaceContent,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>